<template>
  <div>
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="100px">
          <el-form-item label="操作类型" prop="operationType">
            <el-input placeholder="请输入操作类型" v-model="searchForm.operationType" clearable></el-input>
          </el-form-item>
          <el-form-item label="操作人" prop="operator">
            <el-input placeholder="请输入操作人" v-model="searchForm.operator" clearable></el-input>
          </el-form-item>
          <el-form-item label="操作时间">
            <el-date-picker
              v-model="searchForm.operationTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template slot='right'>
        <el-button icon="el-icon-refresh" @click="refresh">刷新</el-button>
      </template>
    </v-centerForm>

    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
    </v-tableEncapsulation>
  </div>
</template>

<script>
import { queryRiskOperationLogList } from '@/api/risk/riskApi'

export default {
  name: 'riskOperationLog',

  data () {
    return {
      searchForm: {
        operationType: null,
        operator: null,
        operationTimeRange: null
      },
      loadingBtn: {
        tableLoading: false
      },
      columnData: [
        {
          type: 'index',
          label: '序号',
          width: '60px'
        },
        {
          label: '操作类型',
          prop: 'operationType',
          width: '150px'
        },
        {
          label: '操作时间',
          prop: 'operationTime',
          width: '160px'
        },
        {
          label: '操作人',
          prop: 'operator',
          width: '120px'
        },
        {
          label: '操作目标',
          prop: 'operationTarget',
          width: '100px'
        },
        {
          label: '目标ID',
          prop: 'targetId',
          width: '100px'
        },
        {
          label: '备注',
          prop: 'remark',
          width: '200px'
        },
        {
          label: 'IP地址',
          prop: 'ip',
          width: '130px'
        }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },

  methods: {
    // 搜索
    search () {
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.operationTimeRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 处理日期范围
      if (params.operationTimeRange && params.operationTimeRange.length === 2) {
        params.operationTimeStart = params.operationTimeRange[0]
        params.operationTimeEnd = params.operationTimeRange[1]
      }
      delete params.operationTimeRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryRiskOperationLogList(params).then(({ data, code }) => {
        if (code === this.$constant.SUCCESS) {
          this.tableData = data.records || []
          this.pagination.total = data.total || 0
        }
        this.loadingBtn.tableLoading = false
      }).catch(() => {
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
</style>
